'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#FCD54E" }),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.00033 5.36667C6.73671 5.36667 7.33366 4.76972 7.33366 4.03334C7.33366 3.29696 6.73671 2.70001 6.00033 2.70001C5.26395 2.70001 4.66699 3.29696 4.66699 4.03334C4.66699 4.76972 5.26395 5.36667 6.00033 5.36667Z",
          fill: "#053C8A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00033 4.70001C5.63214 4.70001 5.33366 4.40153 5.33366 4.03334C5.33366 3.66515 5.63214 3.36667 6.00033 3.36667C6.36852 3.36667 6.66699 3.66515 6.66699 4.03334C6.66699 4.40153 6.36852 4.70001 6.00033 4.70001ZM8.66699 4.70001C8.2988 4.70001 8.00033 4.40153 8.00033 4.03334C8.00033 3.66515 8.2988 3.36667 8.66699 3.36667C9.03518 3.36667 9.33366 3.66515 9.33366 4.03334C9.33366 4.40153 9.03518 4.70001 8.66699 4.70001ZM3.33366 4.70001C2.96547 4.70001 2.66699 4.40153 2.66699 4.03334C2.66699 3.66515 2.96547 3.36667 3.33366 3.36667C3.70185 3.36667 4.00033 3.66515 4.00033 4.03334C4.00033 4.40153 3.70185 4.70001 3.33366 4.70001ZM6.00033 2.03334C5.63214 2.03334 5.33366 1.73486 5.33366 1.36667C5.33366 0.998482 5.63214 0.700012 6.00033 0.700012C6.36852 0.700012 6.66699 0.998482 6.66699 1.36667C6.66699 1.73486 6.36852 2.03334 6.00033 2.03334ZM6.00033 7.36667C5.63214 7.36667 5.33366 7.0682 5.33366 6.70001C5.33366 6.33182 5.63214 6.03334 6.00033 6.03334C6.36852 6.03334 6.66699 6.33182 6.66699 6.70001C6.66699 7.0682 6.36852 7.36667 6.00033 7.36667Z",
          fill: "#FDD650"
        }
      )
    ]
  }
);
const VpFlagNuAsset = forwardRef(FlagNuAsset);

export { VpFlagNuAsset as default };
